module.exports = __webpack_public_path__ + "img/header-background-ms.a4cd1ee0.png";